export const TID = {
  // Auth
  authEmail: "auth-email-input",
  authPassword: "auth-password-input",
  authName: "auth-name-input",
  loginSubmit: "login-submit-btn",
  registerSubmit: "register-submit-btn",
  toggleAuthMode: "toggle-auth-mode",
  authError: "auth-error",

  // Layout
  logoutBtn: "logout-btn",
  navToday: "nav-today",
  navCalendar: "nav-calendar",
  navStats: "nav-stats",
  navPatterns: "nav-patterns",
  currencySelect: "currency-select",
  yearSelect: "year-select",

  // Today (guided flow)
  todayDidTradeYes: "today-did-trade-yes",
  todayDidTradeNo: "today-did-trade-no",
  todayNoPositionsConfirmed: "today-no-positions-confirmed",
  todayPairInput: "today-pair-input",
  todayPairOption: (p) => `today-pair-option-${p.replace(/[/]/g, "-")}`,
  todayDirectionLong: "today-direction-long",
  todayDirectionShort: "today-direction-short",
  todayLotSize: "today-lot-size",
  todayEntry: "today-entry",
  todayExit: "today-exit",
  todayPnl: "today-pnl",
  todayOutcomeWin: "today-outcome-win",
  todayOutcomeLoss: "today-outcome-loss",
  todayOutcomeBreakeven: "today-outcome-breakeven",
  todaySummary: "today-summary",
  todayNextStep: "today-next-step",
  todayBackStep: "today-back-step",
  todaySaveTrade: "today-save-trade",
  todayAddAnother: "today-add-another",
  todayDoneForDay: "today-done-for-day",

  // Streak
  streakCurrent: "streak-current",
  streakLongest: "streak-longest",

  // Calendar
  calendarGrid: "annual-calendar",
  dayCell: (date) => `day-cell-${date}`,

  // Day modal
  dayModal: "day-entry-modal",
  fieldSetup: "field-setup",
  fieldReasoning: "field-reasoning",
  fieldEmotions: "field-emotions",
  fieldMistakes: "field-mistakes",
  fieldLessons: "field-lessons",
  saveEntry: "save-entry-btn",
  deleteEntry: "delete-entry-btn",
  closeModal: "close-modal-btn",
  addTrade: "add-trade-btn",
  removeTrade: (i) => `remove-trade-${i}`,
  tradePair: (i) => `trade-pair-${i}`,
  tradeDirection: (i) => `trade-direction-${i}`,
  tradeLot: (i) => `trade-lot-${i}`,
  tradeEntry: (i) => `trade-entry-${i}`,
  tradeExit: (i) => `trade-exit-${i}`,
  tradePnl: (i) => `trade-pnl-${i}`,
  tradeRegionGood: (i) => `trade-region-good-${i}`,
  tradeRegionBad: (i) => `trade-region-bad-${i}`,
  dayTotalPnl: "day-total-pnl",
  aiReviewBtn: "ai-review-btn",
  aiReviewText: "ai-review-text",

  // Stats
  statTotalPnl: "stat-total-pnl",
  statWinRate: "stat-win-rate",
  statTrades: "stat-trades",
  statDays: "stat-days",

  // Patterns
  patternItem: (i) => `pattern-item-${i}`,
};
